module.exports = __webpack_public_path__ + "img/jetbrains-mono-white.ae550c19.svg";